import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Puts a newly opened page at the top.
 *
 * A single-page app does not reload, so the window keeps whatever scroll offset
 * the previous screen had. Clicking "Build report" from halfway down a 600-row
 * register landed the user halfway down the report — past the heading, past the
 * totals, somewhere in a table — which reads as a broken page rather than a
 * scrolled one.
 *
 * POP is excluded deliberately. Going Back must restore where the user was: the
 * register's filters live in the URL precisely so returning to it lands on the row
 * they came from, and scrolling that to the top would undo the point of it.
 *
 * Keyed on pathname only, not on search. The register rewrites its query string on
 * every filter change and keystroke, and jumping to the top mid-typing would fight
 * the user.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP') return

    // 'instant', not smooth: this is not a movement the user asked for, and
    // animating it makes an already-loaded page feel slow.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, navigationType])

  return null
}
